// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"e3228389","990":"101108e6"}[chunkId] + ".chunk.js";
};